module.exports = __webpack_public_path__ + "static/media/mn.47e61f21.jpg";